export const COLORS = {
  primaryLight: '#069C9C',
  primaryMedium: '#365e61',
  primaryDark: '#025248',
  primaryExtraDark: '#043B3B',
  neutralLight: '#E4EDED',
  neutralMedium: '#686c6d',
  neutralDark: '#000402',
  gray: '#686c6d'
}